import { render, staticRenderFns } from "./VideoCreate.vue?vue&type=template&id=bacbd8b6&"
import script from "./VideoCreate.vue?vue&type=script&lang=js&"
export * from "./VideoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports